import { Headphones, ExternalLink } from "lucide-react";
import SectionReveal from "@/components/SectionReveal";
import useSeo from "@/hooks/useSeo";

export default function Podcast() {
  useSeo({
    title: "Pip's Magnificent Midlife Podcast · Pip Bennett",
    description: "Conversations on midlife, menopause, identity, relationships and meaningful change. Hosted by Pip Bennett.",
    canonical: "https://pipbennett.com/podcast",
  });
  return (
    <section className="py-20 md:py-32" data-testid="page-podcast">
      <div className="max-w-5xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <SectionReveal className="lg:col-span-7">
          <div className="eyebrow mb-4 text-sage">The Podcast</div>
          <h1 className="font-serif-display text-4xl md:text-6xl text-ink leading-[1.05]">
            Pip&rsquo;s <em className="italic text-sage">Magnificent Midlife</em> Podcast.
          </h1>
          <p className="mt-6 text-ink-soft max-w-xl leading-relaxed text-lg">
            Conversations on clarity, behavioural change, and the quiet power of knowing yourself. Short, honest,
            and made for the in-between moments — the commute, the walk, the last five minutes before sleep.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="https://open.spotify.com/show/0VaUEuK7KOrBv19THWGM2v"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-sage hover:bg-sage-dark text-cream rounded-full px-8 py-4 font-medium tracking-wide transition-all"
              data-testid="podcast-spotify"
            >
              <Headphones size={16} strokeWidth={1.8} /> Listen on Spotify
              <ExternalLink size={14} strokeWidth={1.8} />
            </a>
          </div>
        </SectionReveal>
        <SectionReveal delay={120} className="lg:col-span-5">
          <div className="bg-ink text-cream rounded-2xl p-10 md:p-14 relative overflow-hidden">
            <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-gold/20 blur-3xl" />
            <Headphones size={36} strokeWidth={1.3} className="text-gold" />
            <div className="mt-6 font-serif-display text-3xl leading-tight">New episodes, quietly.</div>
            <p className="mt-4 text-cream/70 leading-relaxed">
              Subscribe on your favourite podcast app to catch new conversations as they drop.
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>
  );
}
